import PhotoPlaceholder from "../PhotoPlaceholder";
import { assetUrl, money } from "../../lib/shopApi";

export const ShopProductCard = ({ product, tint, onOpen }) => {
  const live = product.status === "live";
  const prices = product.variants.map((v) => v.price);
  const from = prices.length ? Math.min(...prices) : 0;
  const image = product.images?.[0];

  return (
    <article
      data-testid={`shop-product-${product.slug}`}
      className="relative flex flex-col bg-[#F9F6F0] border border-[#E7DFD5] rounded-md page-shadow overflow-hidden hover:-translate-y-[2px] transition-all duration-700"
    >
      <div className="absolute top-0 left-0 right-0 h-1.5" style={{ background: tint }} />
      {live && (
        <button
          type="button"
          onClick={() => onOpen(product)}
          aria-label={`View ${product.title}`}
          data-testid={`shop-product-open-${product.slug}`}
          className="absolute inset-0 z-10"
        />
      )}
      <div className="p-4">
        {image ? (
          <div className="aspect-square bg-white rounded overflow-hidden">
            <img src={assetUrl(image)} alt={product.title} className="w-full h-full object-contain" loading="lazy" />
          </div>
        ) : (
          <PhotoPlaceholder label={product.title} aspect="square" accent={tint} />
        )}
      </div>
      <div className="px-6 pb-6 flex flex-col flex-grow">
        <p className="text-xs uppercase tracking-[0.25em] mb-2" style={{ color: tint }}>
          {product.kind}
        </p>
        <h3 className="font-display text-2xl text-[#4B3A2F] leading-tight mb-2">{product.title}</h3>
        <p className="font-body text-sm text-[#2C2724]/80 leading-relaxed flex-grow line-clamp-3">
          {product.description}
        </p>
        <div className="mt-5 flex items-center gap-3 flex-wrap">
          <span
            className={`inline-block px-4 py-1.5 rounded-full text-xs uppercase tracking-[0.2em] text-white ${live ? "" : "coming-soon-flash"}`}
            style={{ background: live ? "#7E9268" : tint }}
          >
            {live ? "Available" : "Coming Soon"}
          </span>
          {live && (
            <span className="font-display text-lg text-[#4B3A2F]" data-testid={`shop-product-price-${product.slug}`}>
              {prices.length > 1 && new Set(prices).size > 1 ? "from " : ""}
              {money(from)}
            </span>
          )}
        </div>
      </div>
    </article>
  );
};
